"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var e=require("../_virtual/_tslib.js"),i=require("react/jsx-runtime"),t=require("styled-components"),a=require("@vds/typography"),o=require("@plans/type-lockups"),n=require("@vds/lines"),l=require("@vds-tokens/core"),r=require("@plans/utilities"),s=require("react"),d=require("../tile/index.js");function p(e){return e&&e.__esModule?e:{default:e}}var c=p(t);const u=c.default(d.default).withConfig({displayName:"StyledTile",componentId:"VDS__sc-1frx0t2-0"})`
  @media (min-width: ${r.breakpoints.tabletSmall.min}) {
    > div {
      border-radius: 32px !important;
      &:before {
        border-radius: 34px !important;
      }
    }
  }
`,m=c.default.div.withConfig({displayName:"TitleWrapper",componentId:"VDS__sc-1frx0t2-1"})`
  > * {
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    display: -webkit-box;
    overflow: hidden;
  }
`,f=c.default.div.withConfig({displayName:"SavingsChartWrapper",componentId:"VDS__sc-1frx0t2-2"})`
  display: flex;
  flex-direction: column;
  gap: ${l.LayoutTokens.space["4X"].value};
  padding: ${l.LayoutTokens.space["6X"].value};
  width: 100%;
  @media (min-width: ${r.breakpoints.tabletSmall.min}) {
    padding: ${l.LayoutTokens.space["8X"].value};
    gap: ${l.LayoutTokens.space["6X"].value};
  }
`,g=c.default.ul.withConfig({displayName:"SavingsChartList",componentId:"VDS__sc-1frx0t2-3"})`
  display: flex;
  flex-direction: column;
  gap: ${l.LayoutTokens.space["4X"].value};
  list-style: none;
  margin: 0;
  padding: 0;
  @media (min-width: ${r.breakpoints.tabletSmall.min}) {
    gap: ${l.LayoutTokens.space["6X"].value};
  }
`,h=c.default.div.withConfig({displayName:"MobilePricingWrapper",componentId:"VDS__sc-1frx0t2-4"})`
  display: flex;
  flex-shrink: 0;
  padding-left: ${l.LayoutTokens.space["2X"].value};
  @media (min-width: ${r.breakpoints.tabletSmall.min}) {
    display: none;
  }
`,y=c.default.div.withConfig({displayName:"DesktopPricingWrapper",componentId:"VDS__sc-1frx0t2-5"})`
  display: none;
  flex-shrink: 0;
  padding-left: ${l.LayoutTokens.space["2X"].value};
  @media (min-width: ${r.breakpoints.tabletSmall.min}) {
    display: flex;
  }
`,b=c.default.li.withConfig({displayName:"SavingsListItem",componentId:"VDS__sc-1frx0t2-6"})`
  color: ${({fontColor:e})=>e};
  display: flex;
  flex-direction: row;
  font-family: ${a.Fonts.VerizonNHGeDS};
  font-size: ${l.TypographyTokens.fontsize.body[16].value};
  font-weight: ${({fontWeight:e})=>e};
  justify-content: space-between;
  list-style: none;
  @media (min-width: ${r.breakpoints.tabletSmall.min}) {
    gap: ${l.LayoutTokens.space["6X"].value};
    font-size: ${l.TypographyTokens.fontsize.title[20].value};
  }
`;exports.default=t=>{const{lists:r,title:d,surface:p="light"}=t,c=e.__rest(t,["lists","title","surface"]),v=t=>t.map(((t,a)=>{var{children:n,pricing:r,bold:s,color:d}=t,c=e.__rest(t,["children","pricing","bold","color"]);return i.jsxs(b,Object.assign({fontColor:"green"===d?"light"===p?l.ColorTokens.palette.green26.value:l.ColorTokens.palette.green36.value:"light"===p?l.ColorTokens.elements.primary.onlight.value:l.ColorTokens.elements.primary.ondark.value,fontWeight:s?l.TypographyTokens.fontweight.bold.value:l.TypographyTokens.fontweight.regular.value},c,{children:[n,i.jsx(y,{children:i.jsx(o.Pricing,Object.assign({size:"medium",viewport:"desktop",surface:p,color:d,uniformSize:!0,bold:s},r))}),i.jsx(h,{children:i.jsx(o.Pricing,Object.assign({size:"small",viewport:"mobile",surface:p,color:d,uniformSize:!0,bold:s},r))})]}),a)}));return i.jsx(u,Object.assign({showBorder:!0,background:"transparent",padding:"0",height:"auto",surface:p,borderRadius:"24px"},c,{onClick:void 0,role:"presentation"},{children:i.jsxs(f,{children:[d&&i.jsx(m,{children:i.jsx(a.Title,Object.assign({bold:!0,size:"small",color:"light"===p?l.ColorTokens.elements.primary.onlight.value:l.ColorTokens.elements.primary.ondark.value},d))}),r.map(((e,t)=>i.jsxs(s.Fragment,{children:[i.jsx(g,Object.assign({},e,{children:v(e.items)})),e&&e.separator&&i.jsx(n.Line,Object.assign({surface:p},e.separator))]},t)))]})}))};
